import { ChevronDown } from "lucide-react";

export default function HeroAside() {
  return (
    <>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-ivory/70 animate-bounce">
        <ChevronDown size={18} />
      </div>
      <div className="absolute right-6 md:right-12 top-1/2 -translate-y-1/2 z-10 hidden lg:block">
        <div className="vertical-text text-[10px] tracking-widest3 uppercase text-ivory/60">
          Est. South Asia — A House of Slow Travel
        </div>
      </div>
    </>
  );
}
